/**
 * Helpers de permisos centralizados en frontend.
 * Espejo de /app/backend/core/permissions.py — usar SIEMPRE estos helpers en lugar
 * de comparar por email hardcodeado en la UI.
 */

const _get = (u) => u || {};

export function isAdmin(user) {
  const r = _get(user).role;
  return r === 'Administrador';
}

export function isSocio(user) {
  if (isAdmin(user)) return true;
  const areas = _get(user).areas || [];
  return areas.includes('Socios');
}

export function isLider(user) {
  return _get(user).role === 'Líder';
}

export function isLiderDe(user, area) {
  return isLider(user) && (_get(user).areas || []).includes(area);
}

export function tienePermiso(user, permiso) {
  if (isSocio(user)) return true;
  return (_get(user).permisos_finanzas || []).includes(permiso);
}

export function tienePermisoEstricto(user, permiso) {
  return (_get(user).permisos_finanzas || []).includes(permiso);
}

// Combinaciones de alto nivel
export function esSuperadmin(user) {
  if (tienePermisoEstricto(user, 'superadmin_root')) return true;
  return isSocio(user) && isAdmin(user);
}

export function esRRHHAvanzado(user) {
  return isSocio(user) || tienePermisoEstricto(user, 'rrhh_avanzado');
}

export function esGestorGastos(user) {
  return isSocio(user) || isLiderDe(user, 'Adm. y Finanzas') || tienePermisoEstricto(user, 'gastos_avanzado');
}

export function esGestorComercial(user) {
  return isSocio(user) || isLiderDe(user, 'Comercial');
}

export function esAprobadorCajaChica(user) {
  return tienePermisoEstricto(user, 'caja_chica_aprobador');
}

export function esSupervisorCajaChica(user) {
  return isLiderDe(user, 'Adm. y Finanzas') || isSocio(user);
}

// Catálogo de permisos (para UI del Panel de Control)
export const PERMISOS_CATALOGO = [
  { key: 'superadmin_root',       label: 'Superadmin (endpoints técnicos, seed, root)', peligroso: true },
  { key: 'rrhh_avanzado',         label: 'RRHH — Comisiones, Comunicaciones, Controles, Repositorio, Vencimientos' },
  { key: 'gastos_avanzado',       label: 'Gastos y Remuneraciones — acceso total' },
  { key: 'caja_chica_aprobador',  label: 'Caja Chica — aprobar solicitudes ≤ umbral' },
  { key: 'caja-chica',            label: 'Caja Chica (permiso legacy)' },
  { key: 'inventarios',           label: 'Inventarios (permiso legacy)' },
  { key: 'reembolsos',            label: 'Reembolsos (permiso legacy)' },
];
